<template>
  <div class="login">
    login
  </div>
</template>

<script>
export default {
    name: 'login',
    data () {
        return {

        };
    }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/login/login.vue